import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
// import { icons } from "../../assets/icons";
// import { imgs } from "../../assets/imgs";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	winSubactivityOne: 5,
}

export const SubtopicOneActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema1], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema1 activity 1");
			ObserverEmitter.emit(EVENTS.tema4.subtopicOne.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub01.sub1_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicOne.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Servicio memorable." />
					<DialogBarNew
						dialog={
							"Comencemos por explorar en detalle el servicio memorable."
						}
						percentage={"35%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Servicio memorable"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub01.sub1_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							"Te has preguntado, ¿para qué nos sirve el servicio memorable?"
						}
						percentage={"70%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub01.sub1_act1_a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							"El servicio memorable es fundamental en hacer que la experiencia de los clientes sea verdaderamente inolvidable, lo que a su vez nos ayuda a convertirnos en su preferencia."
						}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.winSubactivityOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winSubactivityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Recuerda incorporar en tu dia a dia, lo que has aprendido."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 10,
									subtema: tasksId.tema4.activities.subtema1,
								})
							);
							navigation("/home4/tema4/subtema1/activityTwo");
						}}
					/>
				</>
			)}

		</>

	)
}